module.exports = __webpack_public_path__ + "img/appAsset--pending-ax.fd7c13c5.svg";